<template lang="pug">
  .general
    h1 You don't have access to the requested scope
</template>

<script>
export default {
  name: 'embedded-scope-error',
  mixins: [],
  props: [],
  data: function () { return {} },
  methods: {},
  computed: {},
  async created () {},
  async mounted () {},
}
</script>
